// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".agent-requests[data-v-803d6f5c]{margin-top:50px}@media only screen and (max-width:1024px){.agent-requests[data-v-803d6f5c]{padding:0 10px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
